<template>
  <div class="news-student">
      <!-- <newsHeader :page="'优秀学员'"></newsHeader> -->
     
      <router-view></router-view>
      <scorllTop></scorllTop>
      <!-- <footer-view></footer-view> -->
  </div>
</template>

<script>
export default {
    // data () {
    //     return {
    //         tealist:[],
    //     }
    // },
    // methods:{
    //     async GetList(){
    //         let parmas ={
    //            type:2, 
    //         }
    //         let resData = await Api.News.getTeaList(parmas)
    //         console.log(resData.rows)
    //         this.tealist = resData.rows
    //   }
    // },
    // mounted(){
    //     this.GetList();
    // }

}
</script>

<style lang="less" scoped>
    @import "../less/news_common.less";
    .news-student {
        background-color: #fff;
        
        .left-section, 
        .right-section {
            width: 592px;
        }

        .student-list{
            padding-top: 28px;
            padding-right: 35px;
        }

        .style-list {
            padding-top: 21px;
        }
    }
</style>